import { ViewStyle } from "react-native";

import { ClassGroupType } from "../../Style.types";

export interface IDisplayClassGroup {
  dNone: ViewStyle;
  dInlineFlex: React.CSSProperties;
  dFlex: ViewStyle;
  zIndex1: ViewStyle;
  zIndex2: ViewStyle;
  zIndex3: ViewStyle;
  zIndex4: ViewStyle;
  zIndex5: ViewStyle;
  zIndex6: ViewStyle;
  zIndex7: ViewStyle;
  zIndex8: ViewStyle;
  zIndex9: ViewStyle;
  zIndex10: ViewStyle;
  zIndex999: ViewStyle;
  zIndex1000: ViewStyle;
}
export const DisplayClassGroup: ClassGroupType<IDisplayClassGroup> = {
  dNone: { display: "none" },
  dInlineFlex: { display: "flex" },
  dFlex: { display: "flex" },
  zIndex1: { zIndex: 1 },
  zIndex2: { zIndex: 2 },
  zIndex3: { zIndex: 3 },
  zIndex4: { zIndex: 4 },
  zIndex5: { zIndex: 5 },
  zIndex6: { zIndex: 6 },
  zIndex7: { zIndex: 7 },
  zIndex8: { zIndex: 8 },
  zIndex9: { zIndex: 9 },
  zIndex10: { zIndex: 10 },
  zIndex999: { zIndex: 999 },
  zIndex1000: { zIndex: 10000 },
};
